// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/front-chart-symbols.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/front-chart-symbols/front-chart-symbols.js';

mount([g0]);
